import React from 'react';
import { Formik, Form } from 'formik';
import { Link, useHistory, useLocation } from 'react-router-dom';

import { useAuth } from 'context/auth';

import Circle from 'components/circle';
import Alert from 'components/alert';
import ErrorMessage from 'components/error-message';
import { PageForm } from 'components/layouts';
import Button from 'components/button';
import Field from 'components/field';

import schema from './schema';

import './style.css';

const Login = () => {
  const { login } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: '/dashboard' } };

  const onSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      const { email, password } = values;
      await login({
        username: email,
        password,
      });
      history.push(from.pathname);
    } catch (e) {
      const {
        response: { data },
      } = e;

      setStatus(data.detail);
      console.error(e);
      setSubmitting(false);
    }
  };

  return (
    <PageForm
      className="-login"
      backTo="/signup"
      backToText="Sign Up"
      title="Login"
      extra={
        <Link className="login-forgot-password" to="forgot-password">
          Forgot Password?
        </Link>
      }
    >
      <Circle
        className="login-circle-02"
        theme="white"
        width="600px"
        angle={260}
        distance={32}
        blur={32}
      />
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        validationSchema={schema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, status }) => (
          <Form>
            <Circle
              className="login-circle-01"
              theme="white"
              width="400px"
              angle={120}
              distance={16}
              blur={16}
            />
            {status ? (
              <Alert
                className="form-general-errors"
                type="error"
                message={status}
              />
            ) : null}

            <ErrorMessage name="email" />
            <Field id="email" name="email" placeholder="Email" type="email" />
            <ErrorMessage name="password" />
            <Field
              id="password"
              name="password"
              placeholder="Password"
              type="password"
            />
            <Button
              type="submit"
              hierarchy="secondary"
              loading={isSubmitting}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Loading' : 'Next'}
            </Button>
          </Form>
        )}
      </Formik>
    </PageForm>
  );
};

export default Login;
